import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
const selectors = {
    announcementBarCarousel: '[data-announcement-bar-carousel]',
    announcementBarCarouselViewport: '[data-announcement-bar-carousel-viewport]',
    announcementBarCarouselPrev: '[data-announcement-bar-carousel-prev]',
    announcementBarCarouselNext: '[data-announcement-bar-carousel-next]',
};
const announcementBar = () => {
    const announcementBarCarousels = document.querySelectorAll(selectors.announcementBarCarousel);
    if (announcementBarCarousels) {
        announcementBarCarousels.forEach((carousel) => {
            const speed = parseInt(carousel.getAttribute('data-carousel-speed'));
            const viewportNode = carousel.querySelector(selectors.announcementBarCarouselViewport);
            const prevButtonNode = carousel.querySelector(selectors.announcementBarCarouselPrev);
            const nextButtonNode = carousel.querySelector(selectors.announcementBarCarouselNext);
            const options = {
                loop: true,
                align: 'start',
            };
            const embla = EmblaCarousel(viewportNode, options, [Autoplay({ playOnInit: true, delay: speed, stopOnInteraction: false, stopOnMouseEnter: true })]);
            prevButtonNode.addEventListener('click', () => embla.scrollPrev(), false);
            nextButtonNode.addEventListener('click', () => embla.scrollNext(), false);
        });
    }
};
export { announcementBar };
